import {  useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TraerMaterialesCotizacion, desSeleccionarDetalle, guardarDetalleFacturacionConCotizacion, limpiarMateriales } from "../../../../actions/compras/AuditoriaFactura";
import {
    Dialog,
    Grid,
    Table,
    TableContainer,
    TableCell,
    TableRow,
    Button,
    TableHead,
    TableBody,
    Typography
} from "@material-ui/core";
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditIcon from "@material-ui/icons/Edit";
import ModalAbm from "../../../compartidos/abms/ModalAbm";
import { FormDetalleConCotizacion } from "./FormDetalleConCotizacion";
import { ModalDocumentacionTramite } from "./ModalDocumentacionTramite";


export const ModalCargarDatosFacturacionConCotizacion = (props) => {
    const { comprobante } = props;
    const dispatch = useDispatch();
    const [openProducto, setOpenProducto] = useState(false);
    const { nuevoDetalleFacturacionSinCotizacion, materialesCotizacion } = useSelector((state) => state.auditoriaFacturacion);
    const [detalleFacturacion, setDetalleFacturacion] = useState([]);
    const [open, setOpen] = useState(false);
    const [material, setMaterial] = useState();
    const [totalFactura, setTotalFactura] = useState();
    const [openDocumentacion, setDocumentacionAlta] = useState(false);
    let detallesEliminar = [];
    let contador = 0;

    useEffect(() => {
        dispatch(TraerMaterialesCotizacion(comprobante.idEfectorFacturacion, comprobante.idSolicitud));
    }, [dispatch, comprobante.idExpediente]);

    
    if (materialesCotizacion.length > 0 && detalleFacturacion.length === 0) {
        materialesCotizacion[0].detalleCotizaciones.map((a) => {
            let documentacion = {};
            documentacion = {
                cantidad: a.cantidadCotizada,
                precioUnitario: a.valorUnitario,
                producto: a.materiales.descripcion,
                idMaterial: a.materiales.codigoNum
            }
            detalleFacturacion.push(documentacion)
            return detalleFacturacion
        }
        )
    }

    useEffect(() => {
        if (totalFactura === 0) {
            setTotalFactura(comprobante.valorCotizacion);
        } else {
            setTotalFactura(contador);
        }
    }, [dispatch, detalleFacturacion])
    useEffect(() => {
        setDetalleFacturacion(detalleFacturacion => detalleFacturacion.concat(nuevoDetalleFacturacionSinCotizacion));
    }, [dispatch, nuevoDetalleFacturacionSinCotizacion]);

    const handleEliminar = (item) => {
        if (detalleFacturacion.length > 1) {
            detallesEliminar = detalleFacturacion.filter(x => x.idMaterial !== item.idMaterial)
            setDetalleFacturacion(detallesEliminar)
        } else {
            detallesEliminar = detalleFacturacion.shift()
            setDetalleFacturacion([])
        }
    }
    const handleMaterialSelect = (item) => {
        
        setMaterial(item)
        setOpen(true)
    }
    const handleEdit = (item) => {
        let value = detalleFacturacion.filter((a) => a.idMaterial === item.idMaterial)
        if (value.length > 0) {
            setDetalleFacturacion(
                detalleFacturacion.map((a) => a.idMaterial === item.idMaterial ?
                    {
                        cantidad: item.cantidad,
                        producto: item.producto,
                        precioUnitario: item.precioUnitario,
                        idMaterial: item.idMaterial
                    }
                    :
                    a
                )

            )
        }
    };
    const handleCancelar = () => {
        dispatch(props.closeModalHandler);
        setDetalleFacturacion([]);
        dispatch(desSeleccionarDetalle())
        dispatch(limpiarMateriales());

    }
    const handleSave = () => {
        dispatch(guardarDetalleFacturacionConCotizacion(comprobante.idExpediente, detalleFacturacion, comprobante.idEfectorFacturacion));
        setDetalleFacturacion([]);
        dispatch(desSeleccionarDetalle());
        props.closeModalHandler();
    };
    console.log(materialesCotizacion);
    return (
        <div>
            {
                openDocumentacion && (
                    <ModalDocumentacionTramite
                        open={openDocumentacion}
                        closeModalHandler={() => setDocumentacionAlta(false)}
                        idExpediente={comprobante.idExpediente}
                    />
                )
            }
            <Dialog
                open={props.open}
                fullWidth
                maxWidth={'lg'}>
                <Grid>
                    <Grid container justify="center" spacing={1}>
                        <Grid item xs={12}>
                            <Typography variant="h5" align="center" style={{ margin: '0.5rem' }}>{comprobante.tipoComprobante} - {comprobante.nroComprobante}</Typography>
                            <Typography variant="h6" align="center" style={{ paddingLeft: '2rem' }}>{`Cotizacion N°: ${comprobante.idSolicitud}`} </Typography>

                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h6" align="left" style={{ paddingLeft: '2rem' }}>{`Valor Cotizacion: $${comprobante.valorCotizacion}`} </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h6" align="left" style={{ paddingLeft: '2rem' }}>{`Valor Facturacion: $${totalFactura}`} </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <ModalAbm title="Agregar Producto" open={openProducto} setOpen={setOpenProducto}>
                                <FormDetalleConCotizacion materiales={null} cerrarModal={() => setOpenProducto(false)} />
                            </ModalAbm>
                            <ModalAbm title="Modificar Material" open={open} setOpen={setOpen}>
                                <FormDetalleConCotizacion materiales={material} handleEdit={handleEdit} cerrarModal={() => setOpen(false)} />
                            </ModalAbm>
                            <Button variant="contained" color="primary" style={{ float: "right"}} onClick={() => setOpenProducto(true)}>+ Agregar Material</Button>
                            <Button variant="contained" color="primary" style={{ float: "right" ,marginRight:'0.5rem'}} onClick={() => setDocumentacionAlta(true)}>Documentacion</Button>

                            <TableContainer style={{ overflowX: "auto", marginTop: '1rem', padding: '2rem' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Material</TableCell>
                                            <TableCell>Cantidad Cotizada</TableCell>
                                            <TableCell>Precio Unitario</TableCell>
                                            <TableCell>Subtotal</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {detalleFacturacion.length > 0 ? (
                                            detalleFacturacion.map((item) => {
                                                contador = (item.precioUnitario * item.cantidad) + contador
                                                return (
                                                    <TableRow>
                                                        <TableCell>{item.producto}</TableCell>
                                                        <TableCell>{item.cantidad}</TableCell>
                                                        <TableCell>{`$${item.precioUnitario}`}</TableCell>
                                                        <TableCell>{`$${item.precioUnitario * item.cantidad}`}</TableCell>
                                                        <TableCell><Button onClick={() => handleEliminar(item)}><DeleteOutlineOutlinedIcon style={{ color: 'red' }} /></Button></TableCell>
                                                        <TableCell><Button onClick={() => handleMaterialSelect(item)}><EditIcon /></Button></TableCell>
                                                    </TableRow>
                                                );
                                            })

                                        ) : (
                                            <TableRow style={{ height: 50 }}>
                                                <TableCell
                                                    colSpan={13}
                                                    style={{ textAlign: "-webkit-center" }}
                                                >
                                                    {" "}
                                                    Sin Registros
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        < TableRow style={{ backgroundColor: "#F7F2F9" }}>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>Total</TableCell>
                                            <TableCell>${contador}</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Grid container style={{ padding: '25px' }}>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={1}
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Button
                                            color="inherit"
                                            variant="contained"
                                            onClick={() => handleCancelar()}
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ textAlign: 'center', marginLeft: '1rem' }}
                                            onClick={() => handleSave()}
                                        >
                                            Guardar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Dialog>
        </div >
    )
}    
